import { render, staticRenderFns } from "./ProjectAdminInfo.vue?vue&type=template&id=244d1f2b&scoped=true"
import script from "./ProjectAdminInfo.vue?vue&type=script&lang=ts"
export * from "./ProjectAdminInfo.vue?vue&type=script&lang=ts"
import style0 from "./ProjectAdminInfo.vue?vue&type=style&index=0&id=244d1f2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d1f2b",
  null
  
)

export default component.exports